// module-level の ref で global state を共有する。SPA (ssr: false) なので
// Nuxt の useState を使わなくても挙動は等価。Storybook / vitest からも素直に動く。
import { ref, readonly, watch } from 'vue'
import { setBodyModalLock } from '~/utils/body-modal-lock'

const isOpen = ref(false)
const toggleModal = () => {
  isOpen.value = !isOpen.value
}
// 明示的に閉じる。false→false は watch が反応しないため冪等。実ナビゲーション
// (path 変化)や error.vue 描画のように、開いたまま離脱して残置した open 状態
// (と body.modal-open)を解除する用途で使う。同一ページ内の v-if 兄弟モーダル差し替えは
// この close を呼ばず isOpen=true を保つため巻き込まない。
const close = () => {
  isOpen.value = false
}

// モーダル表示中は背面(body)のスクロールを止める。isOpen は全モーダル共有のグローバル
// 状態なので、ここに単一の watcher を張れば全 CommonsModal を賄える(各インスタンスに
// 置くと重複する)。背面ロックとスクロールバー幅補償は setBodyModalLock に集約している。
watch(isOpen, (open) => {
  setBodyModalLock(open)
})

export const useModal = () => {
  return {
    isOpen: readonly(isOpen),
    toggleModal,
    close,
  }
}
